export default __webpack_public_path__ + "static/media/environment.891fc21c.png";